<template>
  <div>
    <b-row align-v="center" class="d-flex align-items-center">
      <b-col cols="6" class="mb-2">
        <label>{{ $t('storage_provider.title') }}</label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="storageProviderFilter"
          :options="storageProvider"
          class="w-100"
          :reduce="(val) => val.value"
          @input="(val) => $emit('update:storageProviderFilter', val)"
          data-cy="storageProviderFilter"
          append-to-body
          :calculate-position="withPopper"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardBody,
  BRow,
  BCol,
  BButton,
} from "bootstrap-vue";
import vSelect from "vue-select";
import popperHelper from "@/libs/popper-helper";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BButton,
    vSelect,
  },
  props: {
    storageProvider: {
      type: Array,
      default: null,
    },
    storageProviderFilter: {
      type: String,
      default: null,
    },
  },
  
  setup() {
    return {
      withPopper: popperHelper.withPopper,
    };
  },
};
</script>
